import { api } from "./api";

/**
 * Fetch from V2 proxy endpoint with graceful fallback to local endpoint.
 * @param {string} v2Path - V2 proxy path (e.g., "/v2/operations")
 * @param {string} fallbackPath - Local fallback path (e.g., "/operations")
 * @param {object} params - Query parameters
 * @returns {{ data: any, source: "v2" | "local" }}
 */
export async function fetchWithV2Fallback(v2Path, fallbackPath, params = {}) {
  try {
    const { data } = await api.get(v2Path, { params, timeout: 10000 });
    return { data, source: "v2" };
  } catch (e) {
    if (fallbackPath) {
      try {
        const { data } = await api.get(fallbackPath, { params });
        return { data, source: "local" };
      } catch {
        return { data: [], source: "local" };
      }
    }
    return { data: [], source: "v2" };
  }
}

/**
 * Fetch from V2 only (no fallback).
 */
export async function fetchV2(path, params = {}) {
  const { data } = await api.get(`/v2${path}`, { params });
  return data;
}
